/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-NevaiMeet-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";

import styles from "./LiveCaptions.module.css";

export const LiveCaptionsOverlay: FC<{ text: string }> = ({ text }) => {
  if (!text.trim()) return null;
  return (
    <div className={styles.overlay} aria-live="polite" role="status">
      {text}
    </div>
  );
};
